import {
	createRelayResource,
	RELAY_RESOURCE_TYPE,
} from '@atlassian/jira-relay-utils/src/services/resources/index.tsx';
import TopNav4UIStateQuery, {
	type AtlaskitAtlassianNavigationNav4UIQuery,
} from '@atlassian/jira-relay/src/__generated__/AtlaskitAtlassianNavigationNav4UIQuery.graphql';
import TopNav4UIStateQueryNew, {
	type AtlassianNavigationNav4Query,
} from '@atlassian/jira-relay/src/__generated__/AtlassianNavigationNav4Query.graphql';

// TODO: Remove this when cleaning up blu-7584-replace-nav4-profile-query
export const topNav4UIStateResource = createRelayResource<AtlaskitAtlassianNavigationNav4UIQuery>({
	type: `${RELAY_RESOURCE_TYPE}_TOPNAV_UI_STATE_RELAY`,
	getQuery: (_, { tenantContext: { cloudId, isAnonymous } }) => ({
		parameters: TopNav4UIStateQuery,
		variables: {
			cloudId,
			isAnonymous,
		},
		options: { fetchPolicy: 'store-and-network' },
	}),
});

export const topNav4UIStateResourceNew = createRelayResource<AtlassianNavigationNav4Query>({
	type: `${RELAY_RESOURCE_TYPE}_TOPNAV_UI_STATE_RELAY_NEW`,
	getQuery: (_, { tenantContext: { cloudId, isAnonymous, atlassianAccountId } }) => ({
		parameters: TopNav4UIStateQueryNew,
		variables: {
			cloudId,
			isAnonymous,
			atlassianAccountId: atlassianAccountId ?? '',
		},
		options: { fetchPolicy: 'store-and-network' },
	}),
});
